import { ReactElement } from "react";

import Content from "@/components/shared/Content";
import UserProfilePage from "@/components/UserProfilePage";
import { layoutModes } from "@/constants/layoutModes";
import { SettingsMenuItem } from "@/constants/sidebarMenus/settings";
import HeaderLayout from "@/layouts/HeaderLayout";
import SidebarMenuLayout from "@/layouts/SidebarMenuLayout";
import WorkspaceLayout from "@/layouts/WorkspaceLayout";

export default function SettingsProfilePage() {
  return (
    <Content>
      <UserProfilePage />
    </Content>
  );
}

SettingsProfilePage.getLayout = (page: ReactElement) => {
  const mode = layoutModes.settings;
  return (
    <WorkspaceLayout mode={mode} title="My Profile">
      <SidebarMenuLayout<SettingsMenuItem> mode={mode} selectedItem="profile">
        <HeaderLayout heading="My Profile" mode={mode}>
          {page}
        </HeaderLayout>
      </SidebarMenuLayout>
    </WorkspaceLayout>
  );
};
